<template>
  <div id="learn-whole">
    <transition name="fade">
      <div :key="appStep"
           v-if="appStep === states.MENU && profile.datas.trial_days_left > 0 && !profile.datas.is_premium && !isMobile"
           class="premium flexwrap clickable" id="mainTrial"
           @click="$router.push({name:'premium'})">
        <span>Il te reste {{ profile.datas.trial_days_left }} jours d'essai gratuit&nbsp;</span> <span>des fonctionnalités Premium&nbsp;</span>
        <i class="fas fa-burn" style="font-size: 0.9em; margin-left: 0.3vw; margin-right: 0.3vw"></i>&nbsp;!
      </div>
    </transition>
    <div id="learn-header">
      <router-link :to="{name: 'saison'}" v-if="appStep === states.MENU">
        <div id="logo" class="clickable flexwrap"
             :style="{ backgroundImage: 'url(https://learnandwatch.s3.eu-west-3.amazonaws.com/logo2.webp)' }">
        </div>
      </router-link>

      <div id="logo" v-else class="clickable flexwrap" style="padding-left: 0.5vw"
           @click="set_appStep(states.MENU)"
      >
        <i class="fas fa-arrow-left" style="font-size: 180%; text-shadow: 0 0 0.4vw #000000aa; color:var(--lightColor)"></i>
      </div>

      <div v-if="appStep === states.MENU" class="paddingRound">
        <div class="normalLink" v-if="!isMobile">
          <router-link :to="{name: 'profile'}" v-if="routeName=='saison'">
            <!--<member-level class="clickable"></member-level>-->
            <div class="flexwrap centercenter" style="background-color: var(--goalBackgroundColor); width: 5vw; height: 1.8vw; border-radius: 2vw;">
              <i class="fa-solid fa-bars" style="font-size: 1.2em;"></i> <span style="font-weight: bold">&nbsp;Menu</span>
            </div>
          </router-link>
          <router-link :to="{name: 'saison'}" class="selectedSettings" v-else>
            <div class="flexwrap centercenter" style="background-color: var(--goalBackgroundColor); width: 5vw; height: 1.8vw; border-radius: 2vw;">
              <i class="fa-solid fa-arrow-left" style="font-size: 1.2em;"></i> <span style="font-weight: bold">&nbsp;Retour</span>
            </div>

          </router-link>
        </div>

        <div v-else @click="mobileToggleMenu()">
          <div class="flexwrap centercenter" style="width: 8vw; height: 8vw; border-radius: 7vw;" :style="mobileMenuShown?'background-color: var(--navBackgroundColor); ':''">

          <i class="fa-solid fa-bars" style="font-size: 1.2em;"></i>
            </div>

        </div>

      </div>

    </div>
    <transition name="down" mode="out-in" appear>
      <div id="dashBoardMenu" v-if="isMobile&&mobileMenuShown">
        <dashboard-menu class="paddingRound"
                        @mobileMenuNavClicked="mobileToggleMenu()"
        ></dashboard-menu>

      </div>
    </transition>
    <div id="main-body" :style="!isMobile?'backgroundImage:url(' + 'https://learnandwatch.s3.eu-west-3.amazonaws.com/blur/' +
               currentShow.background_path + '),'  +
                'linear-gradient(0deg, rgba(4,4,4,0.6) 0%, rgba(4,4,4,0) 15%, rgba(4,4,4,0) 80%, rgba(4,4,4,0.6) 100%);':
                ''">
      <router-view name="nav" id="learn-nav"  class="bigShadow" v-show="(!isMobile || (mobileNavIs === mobileNav.nav))" v-if="routeName==='saison' || !isMobile"></router-view>
        <router-view name="content" id="learn-content" v-show="(!isMobile || (mobileNavIs === mobileNav.content))" :style="appStep==states.MENU?'background-color:var(--goalBackgroundColor3)': 'min-width:100vw;'"></router-view>

    </div>
    <div id="learn-footer" v-if="(!isMobile)&&appStep==states.MENU&&$route.name=='saison'" class="paddingRound">
      <VueFooter></VueFooter>
    </div>
    <nav-footer v-if="(isMobile)"
        :current-nav="mobileNavIs"
        @mobileChangeNav="mobileChangeNav"
    ></nav-footer>
  </div>

</template>

<script>
import {API_URL} from "@/App";
import axios from "axios";
import {mapGetters, mapActions} from 'vuex'


export default {
  name: "learn",
  components: {
    DashboardMenu: () => import(/* webpackPrefetch: true */ '@/components/dashboardMenu.vue'),
    MemberLevel: () => import(/* webpackPrefetch: true */ '@/components/member-level.vue'),
    NavFooter: () => import(/* webpackPrefetch: true */ '@/components/navFooter.vue'),
    VueFooter: () => import(/* webpackPrefetch: true */ '@/components/vuefooter.vue'),
  },

  created() {
    this.mobileNavIs = this.mobileNav.content;
    this.fetchUserProfile();
  },


  computed: {
    ...mapGetters('global', [
        'isMobile', 'appStep',
        'states',
        'profile',
        'routeName',
        'dataReload'
    ]),
    ...mapGetters('show', [
      'currentShow',
      'seasonRequested'
    ]),

    onGoingSession: function() {
      if(this.appStep === this.states.ONGOING_SESSION || this.appStep === this.states.WATCH_CARD) {
        return true
      }
      return false
    }
  },

  methods: {
    ...mapActions('global', [
        'set_appStep',
        'set_profile',
        'set_userDatas',
        'change_userData',
        'set_dataLoaded',
        'set_authenticated',
        'set_showsData',
        'set_seasonsData',
        'set_level_copper',
        'set_level_silver',
        'set_level_gold',
    ]),

    fetchUserProfile() {
      this.$webAuth.checkSession({}, (error, authResult) => {
        if(error) {
          this.$router.replace({name: 'landingPage'})
        }
        else if(!error) {
          this.$webAuth.client.userInfo(authResult.accessToken, (error, profileResult) => {
            if (error) {
              console.log(error)
              return;
            }
            this.set_profile(profileResult);

            let tidioScript = document.createElement('script')
            tidioScript.setAttribute('src', '//code.tidio.co/prtwotxhvpv3xdsavd1xo9kijvabmqrp.js')
            document.head.appendChild(tidioScript)

            let awsScript = document.createElement('script')
            awsScript.setAttribute('src', 'https://sdk.amazonaws.com/js/aws-sdk-2.798.0.min.js')
            document.head.appendChild(awsScript)



            this.fetchAuth0User();
            this.set_authenticated(true)
          });
        }
      });
    },

    fetchAuth0User() {
      this.$webAuth.checkSession({}, (error, authResult) => {
        if(!error) {
          let tempUser = null
          let connexionType = -1
          if(this.$session.has('user')) {
            tempUser = this.$session.get('user')
            connexionType = this.$session.get('connexionType')
          }
          else if(this.$cookies.isKey('user')) {
            tempUser = this.$cookies.get('user')
            connexionType = this.$cookies.get('connexionType')
          }
          const url = `${API_URL}/api/auth0user/`

          if(tempUser != null && connexionType === 0) {
            if(!this.$isDebug){
              gtag('event', 'user signs up', {
                'event_category': 'Navigation',
                'event_label': 'newSignUp'
              })

              fbq('track', 'newSignUp');
            }
            axios.patch(url, tempUser, {headers: {Authorization: `Bearer ${authResult.accessToken}`}})
              .then(response => {
                this.manageUserDatas(url, authResult.accessToken)
                this.$cookies.remove('user')
                this.$session.remove('user')
              })
              .catch(error => {
                this.manageUserDatas(url, authResult.accessToken)
                this.$cookies.remove('user')
                this.$session.remove('user')
                console.log(error)
              })
          }

          else {
            this.manageUserDatas(url, authResult.accessToken)
          }
        }
        else {
          console.log(error)
        }
      })
    },

    manageUserDatas: function(url, token) {
      axios.get(url, {headers: {Authorization: `Bearer ${token}`}})
          .then(response => {
            return response.data;
          })
          .then(data => {
            this.set_userDatas(data)

            function get_level(data, num) {
              if (data != undefined && data != null) {
                let ret_val = 0
                for (const element of data) {
                  if (element['knowledge_level'] == num ||(num==3&&element['knowledge_level'] >= 3)) {
                    ret_val += element['the_count']
                  }
                }
                return ret_val
              }
              return 0
            }


            if (data.level_count != undefined) {
              let lev = get_level(data.level_count, 1)
              this.set_level_copper(lev);
              this.set_level_silver(get_level(data.level_count, 2));
              this.set_level_gold(get_level(data.level_count, 3));
            }

            if(data.ongoing_season_obj != null){

              var show_key = data.ongoing_show_obj.id;
              var show_obj = {};

              show_obj[show_key] = data.ongoing_show_obj;

              var season_key = data.ongoing_season_obj.id;
              var season_obj = {};

              season_obj[season_key] = data.ongoing_season_obj;

              this.set_showsData(show_obj)
              this.set_seasonsData(season_obj)
            }
            this.set_dataLoaded({name: 'user', value: true});
          })

      let url2 = `${API_URL}/api/ongoing/${this.profile.sub}/`

      axios.get(url2, {headers: {Authorization: `Bearer ${token}`}})
          .then(response => {
            return response.data;
          })
          .then(data => {
            this.set_showsData(data.ongoing_shows)
            this.set_seasonsData(data.ongoing_seasons)
            this.change_userData({name: 'user_seasons', value: data.user_seasons})
            this.set_dataLoaded({name: 'ongoing', value: true});
          });
    },

    mobileChangeNav: function(newNav) {
      this.set_appStep(this.states.MENU)
      if(newNav === this.mobileNav.content) {
        this.mobileNavIs = this.mobileNav.content;
      }
      else if(newNav === this.mobileNav.nav) {
        this.mobileNavIs = this.mobileNav.nav;
      }
    },

    mobileToggleMenu: function() {
      this.mobileMenuShown = !this.mobileMenuShown;
    }
  },

  watch: {
    // On s'assure que sur mobile le contenu affiché sera de type content (la nav ne sert qu'à la progression sur mobile
    'routeName': function() {
      if(this.isMobile && this.routeName !== 'saison') {
        this.mobileNavIs = this.mobileNav.content;
      }
      this.set_appStep(this.states.MENU)
    },

    'dataReload': 'fetchAuth0User',
    'seasonRequested': function() {
      this.mobileNavIs = this.mobileNav.content
    }
  },

  data() {
    return {
      mobileNav: {
        content: 'content',
        nav: 'nav'
      },
      mobileNavIs: '',
      mobileMenuShown: false
    }
  },
}
</script>

<style scoped>
  .hidden {
    display: none;
  }

  #learn-whole {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  #learn-header {
    height: 3vw;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    position: absolute;
    z-index: 10000;
    min-width: 23vw;
    max-width: 23vw;
    color: var(--navBackgroundColor);
  }

  #logo {
    margin-left: 1.2vw;
    height: 1.5vw;
    width: 6vw;
    align-content: center;

    background-size: contain;
    background-repeat: no-repeat;
  }

  #main-body {
    display: flex;
    flex-direction: row;
    align-content: center;
    align-items: center;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    position: relative;
    justify-content: flex-end;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }

  #learn-nav {
    height: calc(100% - 3vw);
    min-width: 23vw;
    max-width: 23vw;
    padding-top: 3vw;
    overflow-y: auto;
    background-color: var(--navBackgroundColor);
  }

  #learn-content {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
    align-items: center;
    transition: all 0.3s ease;
    min-width: 77vw;
    height: 100%;

  }

  #learn-footer {
    height: auto;
    margin-left: auto;
    position: absolute;
    bottom: 0;
    right: 0;
  }

  .slide-item {
    transition: all 0.8s;
    display: inline-block;
  }

  .slide-enter, .slide-leave-to
    /* .slide-complete-leave-active below version 2.1.8 */
  {
    opacity: 0;
    transform: translateX(-50vw);
  }

  .slide-leave-active {
    position: absolute;
  }

  .slide-move {
    /*transition: transform 3s;*/
  }


  @media screen and (max-device-width: 767px) {
    #learn-whole {
      background: var(--navBackgroundColor);
      height: calc(var(--vh, 1vh) * 100);
      max-height: calc(var(--vh, 1vh) * 100);
    }
    #learn-header {
      width: auto;
      height: 12vw;
      min-width: 100vw;
      max-width: 100vw;

      background-color: black;

      color: var(--goalBackgroundColor3);
      align-items: center;
      z-index: 50;
      position: relative;
    }

    #logo {
      height: 12vw;
      width: 20vw;
      margin: 1vw 2.5vw 1vw 2.5vw;
      background-position: center center;
    }

    #dashBoardMenu {
      z-index: 49;
      position: absolute;
      width: max-content;
      max-width: 100%;
      right: 0;
      top: 12vw;
      height: max-content;
      background-color: black;
    }

    .down-enter /* .fade-leave-active below version 2.1.8 */
    {
      transform: translateY(-75vh);

    }
    .down-enter-active {
      transition: all .3s;
      -webkit-transition: all .3s;
      -ms-transition: all .3s;
    }

    #learn-nav {
      display: inherit;
      width: 100%;
      height: 100%;
      padding: 0;
      min-width: 100vw;
      max-width: 100vw;
    }

    #learn-content {
      display: inherit;
      width: 100%;
      height: 100%;
      padding: 0px;
    }

    #main-body {
      display: block;
      width: 100%;
      height: 100%;
      max-height: 100%;
      overflow: auto;
    }
  }



</style>